import type { AiRepairSessionResult } from '../../../ai-repair';
import type { RepairPreview } from '../types';

export const buildRepairPreviewFromResult = (
  result: AiRepairSessionResult
): RepairPreview | null => {
  if (result.status !== 'success' || !result.repairedEvents) {
    return null;
  }

  return {
    repairedOnly: result.repairedOnly ?? [],
    repairedEvents: result.repairedEvents,
    originalCount: result.originalCount,
    repairedCount: result.repairedCount ?? result.repairedEvents.length,
  };
};
